import {
  Button,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "alm-react-components";
import { useContext, useEffect, useState } from "react";
import { apis } from "../../../services/alm";
import CarouselSection from "../../common/CarouselSection";
import useLibrarySeeAll from "../../../hooks/useLibrarySeeAll";
import { APPROUTES, constants } from "../../../assets/constants/constants";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../context/AppProvider";
import NotesTab from "./Mystance-Tab-Section/NotesTab";
import useNotesTabDataHook from "../../../hooks/useNotesTabDataHook";
import useAlmCorporateStatus from "../../../hooks/useAlmCorporateStatus";
const MyClasses = () => {
  const [bookMarkedItems, setBookmarkedItems] = useState([]);
  const [activeTab, setActiveTab] = useState("mynotestab");
  const { dispatch } = useContext(AppContext);
  const { deleteBookMark, bookMarkresponse } = useLibrarySeeAll();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { notesData, noteDataMapping } = useNotesTabDataHook();
  useAlmCorporateStatus();
  const getBookmarks = async () => {
    try {
      const result = await apis.myBookmarks();
      setBookmarkedItems(result?.data);
      dispatch({ type: "LIBRARY_DATA", payload: { bookmark: result?.data } });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getBookmarks();
  }, [bookMarkresponse]);

  return (
    <>
      <section className="">
        <div className="w-[100%] mx-auto xl:px-32 lg:px-8 md:px-8 px-5 py-6 md:py-14">
          <div className="md:flex md:items-center md:justify-between mb-4 md:mb-0">
            <div className="min-w-0 flex-1  md:pb-10">
              <h1
                className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light"
                dangerouslySetInnerHTML={{ __html: t("MyClass.myClassText") }}
              />
            </div>
          </div>
          <div className="w-full">
            <div className="mt-1 text-sm leading-6 md:mt-0">
              <Tabs defaultValue="mynotestab" className="w-full bg-transparent">
                <TabsList className="w-full bg-transparent items-start justify-start border-b rounded-none h-auto px-0 p-0">
                  <TabsTrigger
                    onClick={() => {
                      setActiveTab("mynotestab");
                      noteDataMapping();
                    }}
                    value="mynotestab"
                    className={`pb-5 pt-5 font-opensansSemiBold text-lg h-auto rounded-none mx-4 ml-0 md:mx-[20px] md:ml-[0px] px-0  ${
                      activeTab === "mynotestab"
                        ? "border-b-[4px] dark:border-primary hover:dark:border-primary hover:dark:text-primary active:dark:border-primary"
                        : ""
                    }`}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("MyStance.myNotes"),
                      }}
                    />
                  </TabsTrigger>

                  <TabsTrigger
                    onClick={() => setActiveTab("mybookmarksTab")}
                    value="mybookmarksTab"
                    className={`pb-5 pt-5 font-opensansSemiBold text-lg h-auto rounded-none mx-4 md:mx-[20px] px-0 ${
                      activeTab === "mybookmarksTab"
                        ? "border-b-[4px] dark:border-primary hover:dark:border-primary hover:dark:text-primary active:dark:border-primary"
                        : ""
                    }`}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("MyStance.myBookMarks"),
                      }}
                    />
                  </TabsTrigger>
                </TabsList>
                <TabsContent value="mynotestab" className="w-full">
                  <NotesTab notesData={notesData} />
                </TabsContent>
                <TabsContent value="mybookmarksTab" className="w-full">
                  <div className="flex flex-wrap justify-end mt-12">
                    {bookMarkedItems?.length > 0 && (
                      <Button
                        variant="outline"
                        onClick={() => navigate(`/bookmark`)}
                        className="w-max h-auto text-base border-0 font-opensansMedium rounded px-8 bg-fillMidGrayCard py-1 md:min-h-10"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t("Common.seeAll"),
                          }}
                        />
                      </Button>
                    )}
                  </div>

                  {bookMarkedItems?.length > 0 ? (
                    <>
                      <CarouselSection
                        type={constants.MY_BOOKMARK}
                        data={bookMarkedItems}
                        deleteBookMark={deleteBookMark}
                        seeAll={true}
                        from={APPROUTES.myStance}
                      />
                    </>
                  ) : (
                    <>
                      <div className="flex justify-center text-2xl">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t("MyStance.noBookMarkAvailable"),
                          }}
                        />
                      </div>
                    </>
                  )}
                </TabsContent>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MyClasses;
